/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentScheduleCountDto } from '../../models/enrollment-schedule-count-dto';

export interface EnrollmentScheduleControllerFindCountV1$Params {
  childId: string;
}

export function enrollmentScheduleControllerFindCountV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerFindCountV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrollmentScheduleCountDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerFindCountV1.PATH, 'get');
  if (params) {
    rb.query('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrollmentScheduleCountDto>;
    })
  );
}

enrollmentScheduleControllerFindCountV1.PATH = '/api/v1/enrollment-schedule/count';
